import { render, staticRenderFns } from "./ObjectsTable.vue?vue&type=template&id=4fc09f76&scoped=true"
import script from "./ObjectsTable.vue?vue&type=script&lang=ts"
export * from "./ObjectsTable.vue?vue&type=script&lang=ts"
import style0 from "./ObjectsTable.vue?vue&type=style&index=0&id=4fc09f76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc09f76",
  null
  
)

export default component.exports